import { resourceToHex } from "../resourceToHex";

/** @deprecated use `resourceToHex` instead */
export const resourceIdToHex = resourceToHex;
